import { render, staticRenderFns } from "./AlarmDetailPage.vue?vue&type=template&id=2a25d57f&scoped=true&"
import script from "./AlarmDetailPage.vue?vue&type=script&lang=js&"
export * from "./AlarmDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./AlarmDetailPage.vue?vue&type=style&index=0&id=2a25d57f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a25d57f",
  null
  
)

export default component.exports